import Layout from '@/components/Layout';
import BasicCard from '@/components/BasicCard';
import {
  CursorArrowRaysIcon,
  ChatBubbleBottomCenterTextIcon,
  CloudIcon,
  PaperAirplaneIcon
 
} from '@heroicons/react/24/outline'
import BasicList from '@/components/BasicList';

const ProjectList = [
  { id: 'ToDO', name: "ToDo List", description: 'A simple To Do tracker', href: 'projects/todos', icon: CursorArrowRaysIcon, newWindow: false },
  { id: 'ChatBot', name: "ChatBot", description: 'A chatBot with different LLM options', href: 'projects/chatBot', icon: ChatBubbleBottomCenterTextIcon, newWindow: false },
  { id: 'Radar', name: "Radar", description: 'Weather Radar', href: 'projects/radar', icon: CloudIcon, newWindow: false },
  { id: 'Flights', name: "Flights", description: 'Flight Tracker', href: 'projects/flights', icon: PaperAirplaneIcon, newWindow: false },
]

const Projects = () => {
  return (
    <Layout>
      <BasicList items={ProjectList}/>
    </Layout>
  );
};

export default Projects;